import { useState } from "react";
import { Container, Paper, Typography, TableContainer, TableRow, TableCell } from "@mui/material";
import FormRegister from "./FormRegister";
import CustomAccordion from  './CustomAccordion';
import { staff, students, teachers, records } from "./";

const RegisterCSV = () => {
    const [expanded, setExpanded] = useState(false);
    const handleChange = (panel) => (event, isExpanded) => setExpanded(isExpanded ? panel : false);
    return(
        <Container component={Paper} sx={{ p: '2em', mb: '2em' }}>
            <Typography align="center" variant="h5">REGISTRO DE USUARIOS POR ARCHIVO CSV</Typography>
            <FormRegister />
            <TableContainer>
                <CustomAccordion expanded={expanded} handleChange={handleChange} panel={staff.panel}
                    title={staff.title}
                    csvHeaders={staff.csvHeaders}
                    headers={staff.headers}
                >
                    <TableRow>
                        <TableCell>Letras y numeros <br /><b>[0-9A-Z] 7</b></TableCell>
                        <TableCell>Solo letras <br /> <b>[A-Z. ÁÉÍÓÚÑ] 3, 250</b></TableCell>
                        <TableCell><b>H</b> = HOMBRE <br /> <b>M</b> = MUJER</TableCell>
                        <TableCell>Solo numeros <br /> <b>28 = REC</b></TableCell>
                    </TableRow>
                </CustomAccordion>

                <CustomAccordion expanded={expanded} handleChange={handleChange} panel={students.panel}
                    title={students.title}
                    csvHeaders={students.csvHeaders}
                    headers={students.headers}
                >
                    <TableRow>
                        <TableCell>Letras y numeros <br /><b>[0-9A-Z] 7, 9</b></TableCell>
                        <TableCell>Solo letras <br /> <b>[A-Z. ÁÉÍÓÚÑ] 3, 250</b></TableCell>
                        <TableCell><b>H</b> = HOMBRE <br /> <b>M</b> = MUJER</TableCell>
                        <TableCell>Numero <br /> <b>1</b> = SI <br /> <b>0</b> = NO</TableCell>
                        <TableCell>Numero <br /> <b>1</b> = ALUMNO <br />  <b>2</b> = EGRESADO <br /> <b>3</b> = INACTIVO</TableCell>
                        <TableCell>ID *numero <br /> <b>23 </b> = LIEC</TableCell>
                        <TableCell>ID *numero  <br /> <b>30</b> = 2020A</TableCell>
                        <TableCell>ID *numero <br /> <b>1</b> = COLOTLÁN</TableCell>
                    </TableRow>
                </CustomAccordion>

                <CustomAccordion expanded={expanded} handleChange={handleChange} panel={teachers.panel}
                    title={teachers.title}
                    csvHeaders={teachers.csvHeaders}
                    headers={teachers.headers}
                >
                    <TableRow>
                        <TableCell>Letras y numeros <br /><b>[0-9A-Z] 7</b></TableCell>
                        <TableCell>Solo letras <br /> <b>[A-Z. ÁÉÍÓÚÑ] 3, 250</b></TableCell>
                        <TableCell><b>H</b> = HOMBRE <br /> <b>M</b> = MUJER</TableCell>
                        <TableCell>ID *numero <br /> <b>17</b> = DFC</TableCell>
                    </TableRow>
                </CustomAccordion>

                <CustomAccordion expanded={expanded} handleChange={handleChange} panel={records.panel}
                    title={records.title}
                    csvHeaders={records.csvHeaders}
                    headers={records.headers}
                >
                    <TableRow>
                        <TableCell>Numeros [0-9]<br /> <b>1</b> = '6GXNx - Evento de Prueba'</TableCell>
                        <TableCell>Letras y numeros <br /> <b>[A-Z0-9] 7, 9</b></TableCell>
                    </TableRow>
                </CustomAccordion>

            </TableContainer>
        </Container>
    )
}

export default RegisterCSV;